import React from 'react';
import { Grid, Typography, Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import { WrappedFieldArrayProps } from 'redux-form';
import { formatMonetaryValue } from 'helpers/math';
import numeral from 'numeral';
import { useTheme } from '@material-ui/core/styles';

const Benefits = ({ formValues = {}, years, swConfig, editData, change }) => {
  const theme = useTheme();

  return (
    <Box bgcolor={theme.palette.primary.dark}>
      <Grid container justify="space-between" alignItems="center" wrap="nowrap">
        <Grid
          item
          xs={4}
          style={{
            padding:
              years === 5
                ? `${theme.spacing(3.5)}px ${theme.spacing(1.5)}px ${theme.spacing(1.25)}px ${theme.spacing(1.5)}px`
                : `${theme.spacing(1.25)}px ${theme.spacing(1.5)}px`,
            borderRight: `1px solid ${theme.palette.primary.main}`,
          }}
        >
          <Typography
            variant="body1"
            style={{ color: theme.palette.common.white }}
          >
            {formatMonetaryValue(
              formValues['total premiums paid to date'],
              false,
            )}
          </Typography>
        </Grid>

        <Grid
          item
          xs={4}
          style={{
            padding:
              years === 5
                ? `${theme.spacing(3.5)}px ${theme.spacing(1.5)}px ${theme.spacing(1.25)}px ${theme.spacing(1.5)}px`
                : `${theme.spacing(1.25)}px ${theme.spacing(1.5)}px`,
            borderRight: `1px solid ${theme.palette.primary.main}`,
          }}
        >
          <Typography
            variant="body1"
            style={{ color: theme.palette.common.white }}
          >
            {years}
          </Typography>
        </Grid>

        <Grid
          item
          xs={4}
          style={{
            padding:
              years === 5
                ? `${theme.spacing(3.5)}px ${theme.spacing(1.5)}px ${theme.spacing(1.25)}px ${theme.spacing(1.5)}px`
                : `${theme.spacing(1.25)}px ${theme.spacing(1.5)}px`,
            borderRight: `1px solid ${theme.palette.primary.main}`,
          }}
        >
          <Typography
            variant="body1"
            align="right"
            style={{ color: theme.palette.common.white, fontWeight: 'bold' }}
          >
            {formatMonetaryValue(formValues['Fund Value'], false)}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

Benefits.propTypes = {
  ...WrappedFieldArrayProps,
  formValues: PropTypes.object,
  theme: PropTypes.object,
  swConfig: PropTypes.object,
  editData: PropTypes.object,
  years: PropTypes.number,
  change: PropTypes.func,
};

export default Benefits;
